<!--
  FileTypesFilter renders a filter with dropdown options for file types
  and reads/writes from the `file_types` URL query param.
-->

<script>
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';

const PARAM_TO_LABEL_MAP = {
  TRUE_PDF: 'True PDF',
  IMAGE_PDF: 'Image PDF',
  IMAGE: 'Image',
};

export default {
  components: {
    iFilter,
  },
  props: {
    analyticsLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      options: Object.values(PARAM_TO_LABEL_MAP).map((o) => ({ label: o })),
    };
  },
  computed: {
    value() {
      const { file_types } = this.params;
      if (!file_types) {
        return [];
      }
      let paramsAsArray = [];
      if (typeof file_types === 'string') {
        paramsAsArray = [file_types];
      } else {
        paramsAsArray = file_types;
      }
      // map query params like 'IMAGE_PDF' to dropdown values like 'Image PDF'
      const formatted = paramsAsArray.map((param) => {
        const [, label] = Object.entries(PARAM_TO_LABEL_MAP).find(
          ([p]) => p === param,
        );
        return label;
      });
      return formatted;
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(updated) {
      const mapEntries = Object.entries(PARAM_TO_LABEL_MAP);
      const updatedParamVals = updated.selection.map((t) => {
        const [param] = mapEntries.find(([_, label]) => label === t.label);
        return param;
      });
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          file_types:
            updatedParamVals.length === 0
              ? undefined
              : updatedParamVals.join(','),
        },
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Format"
    :options="options"
    :model-value="value"
    :searchable="false"
    :data-dd-action-name="analyticsLabel"
    @selection-changed="onSelectionChanged"
  />
</template>
